module.exports = __webpack_public_path__ + "img/4.a84ce6d6.png";